
import { LetterType, Letter, Link } from '../types/letterGraph';


export const getColor = (t: LetterType): string => {
    if (t === 'Исходящее') return '#97C2FC';
    if (t === 'Входящее') return '#A1E6A1';
    return '#F3E97A';
};


export const getEdgeColor = (fromType: LetterType, toType: LetterType): string => {
    // Исходящее -> Исходящее - синий
    if (fromType === 'Исходящее' && toType === 'Исходящее') {
        return '#4A90E2';
    }
    // Входящее -> Входящее - зеленый
    if (fromType === 'Входящее' && toType === 'Входящее') {
        return '#52C41A';
    }
    // Исходящее -> Входящее - фиолетовый
    if (fromType === 'Исходящее' && toType === 'Входящее') {
        return '#722ED1';
    }
    // Входящее -> Исходящее - оранжевый
    if (fromType === 'Входящее' && toType === 'Исходящее') {
        return '#FA8C16';
    }
    // С другими типами - серый
    return '#8C8C8C';
};


export const getChainNodes = (rootId: number, letters: Letter[], edges: Link[]): Letter[] => {
    const chain: Letter[] = [];
    const visited = new Set<number>();
    const queue = [rootId];
    
    while (queue.length > 0) {
        const currentId = queue.shift()!;
        if (visited.has(currentId)) continue;
        visited.add(currentId);
        
        const letter = letters.find(l => l.id === currentId);
        if (letter) {
            chain.push(letter);
            edges.filter(e => e.from === currentId).forEach(e => {
                if (!visited.has(e.to)) {
                    queue.push(e.to);
                }
            });
        }
    }
    
    return chain.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
};


export const getRootNodes = (letters: Letter[], edges: Link[]): number[] => {
    const allNodeIds = new Set(letters.map(l => l.id));
    const hasIncoming = new Set<number>();
    
    edges.forEach(e => {
        hasIncoming.add(e.to);
    });
    
    return letters
        .filter(l => {
            const hasParentInGraph = l.parent_id && typeof l.parent_id === 'number' && allNodeIds.has(l.parent_id);
            return !hasIncoming.has(l.id) && !hasParentInGraph;
        })
        .map(l => l.id);
};


export const getLettersWithoutResponse = (letters: Letter[], edges: Link[]): Set<number> => {
    const hasOutgoing = new Set<number>();
    edges.forEach(e => {
        hasOutgoing.add(e.from);
    });
    
    const withoutResponse = new Set<number>();
    letters.forEach(l => {
        if (!hasOutgoing.has(l.id)) {
            withoutResponse.add(l.id);
        }
    });
    
    return withoutResponse;
};

